import { DragHandleDots2Icon } from "@radix-ui/react-icons";
import * as ResizablePrimitive from "react-resizable-panels";

import { cn } from "@/lib/utils";
import React from "react";

const ResizablePanelGroup = React.memo(
  ({
    className,
    ...props
  }: React.ComponentProps<typeof ResizablePrimitive.PanelGroup>) => (
    <ResizablePrimitive.PanelGroup
      className={cn(
        "flex h-full w-full data-[panel-group-direction=vertical]:flex-col",
        className,
      )}
      {...props}
    />
  ),
);

const ResizablePanel = ResizablePrimitive.Panel;

type ResizableHandleProps = React.ComponentProps<
  typeof ResizablePrimitive.PanelResizeHandle
> & {
  withHandle?: boolean;
  showOnHover?: boolean;
};

const ResizableHandle = React.memo(
  ({
    withHandle,
    showOnHover = false,
    className,
    ...props
  }: ResizableHandleProps) => (
    <ResizablePrimitive.PanelResizeHandle
      className={cn(
        "relative flex w-px items-center justify-center bg-border after:absolute after:inset-y-0 after:left-1/2 after:w-1 after:-translate-x-1/2 focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-1 data-[panel-group-direction=vertical]:h-px data-[panel-group-direction=vertical]:w-full data-[panel-group-direction=vertical]:after:left-0 data-[panel-group-direction=vertical]:after:h-1 data-[panel-group-direction=vertical]:after:w-full data-[panel-group-direction=vertical]:after:-translate-y-1/2 data-[panel-group-direction=vertical]:after:translate-x-0 [&[data-panel-group-direction=vertical]>div]:rotate-90",
        showOnHover && [
          "group/resizable-handle",
          "before:absolute before:content-[''] before:-inset-y-2 before:-inset-x-1 before:pointer-events-auto before:bg-transparent",
          "data-[panel-group-direction=vertical]:before:-inset-y-1 data-[panel-group-direction=vertical]:before:-inset-x-2",
        ],
        className,
      )}
      {...props}
    >
      {withHandle && (
        <div
          className={cn(
            "z-10001 flex h-4 w-3 items-center justify-center rounded-sm border bg-border transition-opacity",
            showOnHover
              ? "opacity-0 group-hover/resizable-handle:opacity-100"
              : "opacity-100",
          )}
        >
          <DragHandleDots2Icon className="h-2.5 w-2.5" />
        </div>
      )}
    </ResizablePrimitive.PanelResizeHandle>
  ),
);

export { ResizablePanelGroup, ResizablePanel, ResizableHandle };
